export class UploadPausedError extends Error { }
export class UploadCancelledError extends Error { }
export class UploadTimeoutError extends Error { }